module.exports = __webpack_public_path__ + "static/media/Murkrow_gaussian2.da1bf417.png";